import { useEffect } from "react";
import styles from "./ModalComponent.module.css";
import ModalButton from "../Buttons/ModalButtons";
import { useTranslation } from "react-i18next";

interface IModalProps {
  isOpen: boolean;
  onClose: () => void;

  headerContent?: React.ReactNode;
  content?: React.ReactNode;
  footerContent?: React.ReactNode;
  customContent?: React.ReactNode;

  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;

  classNameTitle?: string;
  classNameContent?: string;
  classNameFooter?: string;
  classNameModal?: string;
  isGreen?: boolean;
}

const ModalComponent: React.FC<IModalProps> = ({
  isOpen,
  onClose,
  content,

  headerContent,
  footerContent,
  customContent,

  onConfirm,
  confirmText,
  cancelText,

  classNameTitle,
  classNameContent,
  classNameFooter,
  classNameModal,
  isGreen = false,
}) => {
  const { t } = useTranslation(["test-bank"]);
  const handleEscape = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  return isOpen ? (
    <div onClick={onClose} className={styles.modal}>
      {/* Контент */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`${styles.modalWrapper} ${classNameModal}`}
      >
        <header className={classNameTitle || styles.title}>
          {headerContent}
        </header>
        <div className={classNameContent || styles.content}>{content}</div>
        <footer className={classNameFooter || styles.footer}>
          {footerContent && (
            <>
              <button className={styles.button} onClick={onClose}>
                {cancelText ? cancelText : t("common:cancel")}
              </button>
              {footerContent}
            </>
          )}
          {!footerContent && !customContent && (
            <ModalButton color="green" onClick={onClose}>
              {confirmText ? confirmText : t("common:accept")}
            </ModalButton>
          )}
          {customContent && <>{customContent}</>}
        </footer>
      </div>
    </div>
  ) : null;
};

export default ModalComponent;
